/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inserting_Blank_FramesInputs */



/**
* | output |
* | --- |
* | "Inserting blank frames..." |
*
* @param {Inserting_Blank_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const inserting_blank_frames = /** @type {((inputs?: Inserting_Blank_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inserting_Blank_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insertion d’images vides...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Frames einfügen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserimento di cornici vuote...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставка пустых рамок...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar marcos en blanco...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入空白帧...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白のフレームを挿入しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली फ्रेम डाले जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserindo molduras em branco...")
	return /** @type {LocalizedString} */ ("Inserting blank frames...")
});